import { render, staticRenderFns } from "./BookingEditForm.vue?vue&type=template&id=23ddf37c&scoped=true"
import script from "./BookingEditForm.vue?vue&type=script&lang=js"
export * from "./BookingEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ddf37c",
  null
  
)

export default component.exports